import { memo } from "react";

import { QuestionOptionDescription as Question } from "@/components/features/items/edit/option/_shared/ui/components/description/description";

import { useOptionDescription } from "./hooks";

export const QuestionOptionDescription = memo(() => {
	const { description, onSetDescription } = useOptionDescription();

	return <Question description={description} onSetDescription={onSetDescription} />;
});

QuestionOptionDescription.displayName = "QuestionOptionDescription";
